<template>
  <v-dialog
    v-model="dialog"
    width="600"
    persistent
    :fullscreen="$vuetify.breakpoint.xsOnly"
  >
    <v-toolbar>
      <v-toolbar-title>{{ $route.meta.nameDrawer }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon @click="closeDialog()"><v-icon>mdi-close</v-icon></v-btn>
    </v-toolbar>
    <v-card>
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-card>
          <div class="px-6 py-4 grey--text">
            <div>{{ $t("to") }}: {{ $route.query.name_agent_extract }}</div>
            <div>Id: {{ $route.params.id_agente }}</div>
            <div>{{ $t("balanceReport") }}: {{ $route.query.balance }}</div>
          </div>
          <v-divider></v-divider>
          <div class="ma-4">
            <v-row>
              <v-col cols="4">
                <div class="pa-4 text-right">{{ $t("type") }}:</div>
              </v-col>
              <v-col cols="8">
                <v-radio-group v-model="radios" row>
                  <v-radio value="1" class="mb-2">
                    <template v-slot:label>
                      <div>
                        <strong class="success--text">{{
                          $t("receiveFromTheAgent")
                        }}</strong>
                      </div>
                    </template>
                  </v-radio>
                  <v-radio value="2" class="mb-2">
                    <template v-slot:label>
                      <div>
                        <strong class="red--text">{{
                          $t("payTheAgent")
                        }}</strong>
                      </div>
                    </template>
                  </v-radio>
                </v-radio-group>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="4">
                <div class="pa-4 text-right">{{ $t("value") }}:</div>
              </v-col>
              <v-col cols="8">
                <v-text-field
                  :label="$t('value')"
                  v-model="valueEntry"
                  :rules="valueEntryRules"
                  required
                  clearable
                  outlined
                  type="number"
                  prefix="R$"
                  dense
                  class="mr-4 mt-2"
                ></v-text-field>
              </v-col>
            </v-row>
          </div>
          <v-divider></v-divider>
          <v-card-actions class="pa-4">
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              :loading="loading"
              v-on:click.prevent="insertEntryAgent"
              type="submit"
              :disabled="!valid"
            >
              {{ $t("toSave") }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-card>
  </v-dialog>
</template>
<script>
import { validate } from "@/util/validate.js";
export default {
  name: "administrator-financial-balance-insert-entry-agent",
  data: () => ({
    valid: false,
    radios: "1",
    valueEntry: "",
    valueEntryRules: [validate.required, validate.negativeNo],
    loading: false,
  }),
  computed: {
    dialog() {
      return this.$store.state.showDialog;
    },
  },
  watch: {
    dialog(val) {
      !val && this.$router.go(-1);
    },
  },
  methods: {
    insertEntryAgent: async function() {
      if (!this.$refs.form.validate()) {
        return;
      }

      this.$store.commit("setFeedbackProgress", true);
      this.loading = true;

      const body = {
        id_agent: this.$route.params.id_agente,
        value: this.valueEntry,
        type: this.radios,
      };
      try {
        const result = await this.$request.post(
          "administrator/financial/insertEntryDeal",
          body
        );

        this.$store.commit("setFeedbackSnack", {
          msg: result.messages,
          color: "success",
        });
        this.$refs.form.reset();
        this.$store.commit("updateListBalance", {
          id_agent: this.$route.params.id_agente,
          value: result.dados.balance,
        });
        this.$store.commit("showDialog", false);
      } finally {
        this.loading = false;
      }
    },
    closeDialog() {
      this.$store.commit("showDialog", false);
    },
  },
};
</script>
